/**
 * Return current environment.
 *
 * @return {string} The environment. Can be `development` or `production`.
 */
export const getEnvironment = () => process.env.NODE_ENV;
